export const MATERIS_GET = 'MATERIS_GET';
export const MATERI_ADD = 'MATERI_ADD';
export const MATERI_GET = 'MATERI_GET';
export const MATERI_EDIT = 'MATERI_EDIT';
export const MATERI_REPORT_NOTIF = 'MATERI_REPORT_NOTIF';
export const MATERI_UPLOADFILE = 'MATERI_UPLOADFILE';
export const MATERI_DELETE = 'MATERI_DELETE';
export const MATERI_RESET_SEARCH = 'MATERI_RESET_SEARCH';
